<div
  class="bp-modal mod-lg"
	[ngClass]="{
		elevated: isFirstStep || (isSecondStep && !!tradableId),
		'no-separator': isThirdStep
	}">
  @if (!summary) {
    @if (currentStep; as header) {
      <bp-modal-header
        class="font-semibold"
        [title]="header.title | translate: [getAssetSymbol()]">
        @if (header.left; as left) {
          <a
            left
            (click)="onHeaderButtonClick(left)"
            (keydown.enter)="onHeaderButtonClick(left)"
            [tabIndex]="0">
            {{ left | translate }}
          </a>
        }
        @if (header.right; as right) {
          <a
            right
            (click)="onHeaderButtonClick(right)"
            (keydown.enter)="onHeaderButtonClick(right)"
            [tabIndex]="0">
            {{ right | translate }}
          </a>
        }
      </bp-modal-header>
    }
    <!-- Modal Body -->
    <div class="bp-modal-body">
      <!-- Step 1 - Select Voucher Type -->
      @if (isFirstStep) {
        <div class="bp-modal-body-section">
          <div class="bp-modal-description">{{ "voucher_select_voucher_info_text" | translate }}</div>
          <div class="modal-grid mod-two-cols">
            @for (voucher of vouchers; track voucher; let i = $index) {
              <voucher-tile
                [ngClass]="'grid-item'"
                [provider]="voucher"
                (click)="selectVoucher(voucher)"
                (keydown.enter)="selectVoucher(voucher)"
                [tabIndex]="-1">
                <span class="color-primary">{{ voucher?.getName() }}</span>
              </voucher-tile>
            }
          </div>
        </div>
      }
      <!-- Step 2 - Select Wallet -->
      @if (isSecondStep) {
        <div
          class="bp-modal-body-section"
					[ngClass]="{
						'mod-no-padding': isSecondStep && !tradableId,
						'pb-0 mod-trade-flow': !!tradableId
					}">
          @if (!!tradableId) {
            <div class="bp-modal-description">
              {{ "voucher_wallet_selection_sub_header" | translate }}
            </div>
          }
          <tradable-list-item
            [(tradableId)]="tradableId"
            (tradableIdChange)="tradableId = $event"
            [action]="'voucher'"
            [customListFilter]="filterTradableList"
            (onSelect)="selectWallet($event)"
          (onRefresh)="doTrapFocusTime()"></tradable-list-item>
        </div>
      }
      <!-- Step 3 - Amounts -->
      @if (isThirdStep) {
        <div class="bp-modal-body-section modal-grey-background pb-20">
          <div class="bp-modal-description">
            {{ "voucher_summary_subheader_information" | translate: [getAssetSymbol(), getAssetSymbol()] }}
          </div>
          <bp-input type="voucher" [placeholder]="'enter_voucher_code' | translate" [(value)]="code">
            {{ "some_info_text_voucher_code" | translate }}
          </bp-input>
        </div>
        <hr class="mb-0 mt-0" />
        <div class="bp-modal-body-section color-black">
          <div class="large-weight font-size-15 pb-10">
            {{ "you_will_receive_voucher_amount" | translate }}
          </div>
          <div class="flex flex-wrap">
            <div>
              <img
                [src]="cryptoCoin?.getLogo()"
                [style.width.px]="32"
                (error)="img.src = cryptoCoin?.getDefaultLogo()"
                alt="{{ 'logo_alt_text' | translate }}"
                #img />
            </div>
            <div class="ml-10 bp-modal-body-section__asset_price_list">
              @for (amount of amounts; track amount) {
                <p>
                  <strong>
                    {{
                    amount?.fiatAmount()
                    | fiat_precision_symbol
                    : { id: fiat?.getId(), symbol: true, currencies: [fiat] }
                    }}
                    ~
                  </strong>
                  {{
                  amount?.tradableAmount()
                  | tradable_precision_symbol
                  : { id: wallet?.getCurrencyId(), ignorePrecision: true }
                  }}
                </p>
              }
            </div>
          </div>
        </div>
        <hr class="mb-0 mt-0" />
        <div class="bp-modal-body-section">
          <div class="container-left-right flex-wrap">
            <button
              class="btn btn-primary btn-friends"
              [ngClass]="{ disabled: !hasTermsAccepted() }"
              (click)="save()">
              {{ "redeem_and_buy" | translate }}
            </button>
          </div>
        </div>
      }
    </div>
  }
</div>
